const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/projects/sales.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createTableQuerySchema } from '@common';
import { hasPermission } from '@hypeit-gmbh/hypeit-ui-core';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { t } from 'i18next';
import { z } from 'zod';
const searchSchema = createTableQuerySchema({}).extend({
  sharedAst: z.string().optional()
});
export const Route = createFileRoute('/_rootLayout/projects/sales')({
  validateSearch: search => searchSchema.parse(search),
  beforeLoad: ({
    context: {
      permissions
    }
  }) => {
    if (!hasPermission(permissions, {
      permission: 'PROJECTS_TICKETSALES',
      action: 'READ'
    })) {
      throw redirect({
        to: '/',
        replace: true,
        throw: true
      });
    }
  },
  loader: async () => ({
    crumb: t('NAVIGATION.TICKET_SALES'),
    to: '/projects/sales'
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});